const round = (value, digits = 1) => Number(value.toFixed(digits));

export function calculate(values) {
  const { ph, pco2, hco3, na, cl, albumin } = values;
  const expectedPh = 6.1 + Math.log10(hco3 / (0.03 * pco2));
  const ag = na - (cl + hco3);
  const correctedAg = ag + 2.5 * (4 - albumin);
  const deltaAg = correctedAg - 12;
  const deltaHco3 = 24 - hco3;
  const deltaRatio = deltaHco3 > 0 && deltaAg > 0 ? deltaAg / deltaHco3 : null;
  const acidemia = ph < 7.35;
  const alkalemia = ph > 7.45;
  let primary = 'pH na faixa de referência';
  let compensation = 'Avalie a tendência de pCO₂ e HCO₃⁻ e o contexto clínico; um pH normal não exclui distúrbios mistos.';
  let expectedPco2 = null;

  if (acidemia && hco3 < 22) {
    primary = 'acidose metabólica';
    expectedPco2 = 1.5 * hco3 + 8;
    compensation = pco2 > expectedPco2 + 2 ? 'pCO₂ acima de Winter: considere acidose respiratória associada.' : pco2 < expectedPco2 - 2 ? 'pCO₂ abaixo de Winter: considere alcalose respiratória associada.' : 'pCO₂ dentro da faixa esperada pela fórmula de Winter.';
  } else if (alkalemia && hco3 > 26) {
    primary = 'alcalose metabólica';
    expectedPco2 = 40 + 0.7 * (hco3 - 24);
    compensation = `pCO₂ esperada ≈ ${round(expectedPco2)} mmHg pela regra de Boston; compare com o quadro clínico.`;
  } else if (acidemia && pco2 > 45) {
    primary = 'acidose respiratória';
    compensation = 'Diferencie início agudo de retenção crônica de CO₂ antes de avaliar a compensação renal.';
  } else if (alkalemia && pco2 < 35) {
    primary = 'alcalose respiratória';
    compensation = 'Diferencie início agudo de hiperventilação crônica antes de avaliar a compensação renal.';
  } else if (acidemia || alkalemia) {
    primary = 'alteração ácido-base não classificada isoladamente';
    compensation = 'Os valores não seguem o padrão simples esperado. Confira os dados e investigue distúrbios mistos.';
  }

  const deltaInterpretation = deltaRatio === null ? 'Não aplicável sem elevação do AG corrigido e queda do bicarbonato.' : deltaRatio < 0.8 ? 'Sugere acidose metabólica de ânion gap normal concomitante.' : deltaRatio > 2 ? 'Sugere alcalose metabólica associada ou bicarbonato previamente elevado.' : 'Compatível com acidose metabólica de ânion gap elevado isolada, em contexto apropriado.';

  return {
    primary,
    compensation,
    expectedPh: round(expectedPh, 2),
    expectedPco2: expectedPco2 === null ? null : round(expectedPco2),
    ag: round(ag),
    correctedAg: round(correctedAg),
    deltaRatio: deltaRatio === null ? null : round(deltaRatio, 2),
    deltaInterpretation,
    phDifference: round(Math.abs(ph - expectedPh), 2)
  };
}
